import React from 'react';
import { Link } from 'react-router-dom';
import { useConsent } from '../components/CookieBanner';

export default function CookiesPage() {
  const { consent, acceptAll, rejectAll, reset } = useConsent();
  const [saved, setSaved] = React.useState(false);

  const handleAccept = () => { acceptAll(); setSaved(true); setTimeout(() => setSaved(false), 2500); };
  const handleReject = () => { rejectAll(); setSaved(true); setTimeout(() => setSaved(false), 2500); };
  const handleReset  = () => { reset();     setSaved(true); setTimeout(() => setSaved(false), 2500); };

  return (
    <div style={{ paddingTop:'var(--nav-h, 64px)', minHeight:'100vh', background:'var(--radar-cream)' }}>
      <div style={{ maxWidth:760, margin:'0 auto', padding:'clamp(32px,6vw,64px) var(--px, clamp(16px,5vw,40px))' }}>
        <p className="section-label" style={{ marginBottom:12 }}>RGPD · Cookies</p>
        <h1 style={{ fontSize:'clamp(28px,5vw,42px)', fontWeight:700, letterSpacing:'-.02em', marginBottom:16 }}>Gestion des cookies</h1>
        <p style={{ fontSize:15, color:'#5A4A3C', lineHeight:1.7, marginBottom:40 }}>
          Vous pouvez modifier vos préférences de cookies à tout moment. Conformément au RGPD, votre consentement est libre, éclairé et révocable.
        </p>

        {/* Current status */}
        <div style={{ padding:'20px 24px', background:'#fff', borderRadius:10, border:'1px solid rgba(140,106,90,.18)', marginBottom:32 }}>
          <p style={{ fontFamily:'var(--font-mono)', fontSize:11, color:'var(--radar-mid)', textTransform:'uppercase', letterSpacing:'.08em', marginBottom:12 }}>État actuel</p>
          {consent ? (
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ fontSize:14 }}>Cookies essentiels</span>
                <span style={{ padding:'3px 10px', background:'rgba(46,125,50,.1)', color:'#2E7D32', borderRadius:3, fontFamily:'var(--font-mono)', fontSize:10 }}>✓ Actifs</span>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ fontSize:14 }}>Cookies analytiques</span>
                <span style={{ padding:'3px 10px', background:consent.analytics?'rgba(46,125,50,.1)':'rgba(198,40,40,.1)', color:consent.analytics?'#2E7D32':'#C62828', borderRadius:3, fontFamily:'var(--font-mono)', fontSize:10 }}>
                  {consent.analytics ? '✓ Acceptés' : '✗ Refusés'}
                </span>
              </div>
              <p style={{ fontSize:12, color:'var(--radar-mid)', marginTop:4, fontFamily:'var(--font-mono)' }}>
                Choix enregistré le {new Date(consent.ts).toLocaleDateString('fr-FR',{day:'numeric',month:'long',year:'numeric'})}
              </p>
            </div>
          ) : (
            <p style={{ fontSize:14, color:'var(--radar-mid)' }}>Aucun choix enregistré.</p>
          )}
        </div>

        {/* Cookie details */}
        <div style={{ display:'flex', flexDirection:'column', gap:16, marginBottom:36 }}>
          {[
            {
              name: 'Cookies essentiels',
              required: true,
              icon: '🔒',
              items: [
                { name:'radar_token', type:'JWT', duration:'7 jours', desc:'Token d\'authentification sécurisé (httpOnly).' },
                { name:'radar_refresh_token', type:'JWT', duration:'30 jours', desc:'Token de renouvellement de session.' },
                { name:'radar_gdpr_v1', type:'LocalStorage', duration:'Permanent', desc:'Enregistrement de votre choix de consentement.' },
              ]
            },
            {
              name: 'Cookies analytiques',
              required: false,
              icon: '📊',
              items: [
                { name:'_analytics_session', type:'Session', duration:'Session', desc:'Mesure de la visite en cours (anonyme).' },
              ]
            },
          ].map(cat => (
            <div key={cat.name} style={{ background:'#fff', borderRadius:10, border:'1px solid rgba(140,106,90,.15)', overflow:'hidden' }}>
              <div style={{ padding:'16px 20px', borderBottom:'1px solid rgba(140,106,90,.08)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <span style={{ fontSize:18 }}>{cat.icon}</span>
                  <span style={{ fontWeight:700, fontSize:15 }}>{cat.name}</span>
                </div>
                <span style={{ padding:'3px 10px', borderRadius:3, fontFamily:'var(--font-mono)', fontSize:10, background:cat.required?'rgba(46,125,50,.1)':'rgba(217,79,0,.1)', color:cat.required?'#2E7D32':'var(--radar-orange)' }}>
                  {cat.required ? 'Obligatoire' : 'Optionnel'}
                </span>
              </div>
              <div style={{ padding:'0 20px' }}>
                {cat.items.map((item, i) => (
                  <div key={item.name} style={{ padding:'14px 0', borderBottom:i<cat.items.length-1?'1px solid rgba(140,106,90,.06)':'none', display:'grid', gridTemplateColumns:'1fr auto', gap:16, alignItems:'start' }}>
                    <div>
                      <p style={{ fontFamily:'var(--font-mono)', fontSize:12, color:'var(--radar-dark)', marginBottom:3, fontWeight:700 }}>{item.name}</p>
                      <p style={{ fontSize:13, color:'#5A4A3C', lineHeight:1.5 }}>{item.desc}</p>
                    </div>
                    <div style={{ textAlign:'right', flexShrink:0 }}>
                      <p style={{ fontFamily:'var(--font-mono)', fontSize:10, color:'var(--radar-mid)' }}>{item.type}</p>
                      <p style={{ fontFamily:'var(--font-mono)', fontSize:10, color:'var(--radar-mid)', whiteSpace:'nowrap' }}>{item.duration}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Actions */}
        {saved && (
          <div style={{ padding:'12px 20px', background:'rgba(46,125,50,.1)', border:'1px solid rgba(46,125,50,.25)', borderRadius:8, marginBottom:20, fontFamily:'var(--font-mono)', fontSize:12, color:'#2E7D32' }}>
            ✓ Vos préférences ont été enregistrées
          </div>
        )}
        <div style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
          <button onClick={handleAccept}
            style={{ flex:'1 1 180px', padding:'13px 20px', background:'var(--radar-gradient)', color:'#fff', border:'none', borderRadius:4, fontFamily:'var(--font-mono)', fontSize:11, cursor:'pointer', letterSpacing:'.04em', textTransform:'uppercase', fontWeight:700 }}>
            Tout accepter
          </button>
          <button onClick={handleReject}
            style={{ flex:'1 1 180px', padding:'13px 20px', background:'none', color:'var(--radar-dark)', border:'1.5px solid rgba(140,106,90,.3)', borderRadius:4, fontFamily:'var(--font-mono)', fontSize:11, cursor:'pointer', letterSpacing:'.04em', textTransform:'uppercase' }}>
            Essentiels seulement
          </button>
          <button onClick={handleReset}
            style={{ flex:'0 0 auto', padding:'13px 16px', background:'none', color:'var(--radar-mid)', border:'1px solid rgba(140,106,90,.2)', borderRadius:4, fontFamily:'var(--font-mono)', fontSize:10, cursor:'pointer', letterSpacing:'.04em', textTransform:'uppercase' }}>
            Réinitialiser
          </button>
        </div>

        <p style={{ marginTop:32, fontSize:13, color:'var(--radar-mid)', lineHeight:1.6 }}>
          Pour plus d'informations, consultez notre{' '}
          <Link to="/confidentialite" style={{ color:'var(--radar-orange)', textDecoration:'underline' }}>politique de confidentialité</Link>{' '}
          et nos{' '}
          <Link to="/mentions-legales" style={{ color:'var(--radar-orange)', textDecoration:'underline' }}>mentions légales</Link>.
        </p>
      </div>
    </div>
  );
}
